import React, { useMemo } from 'react';
import DashboardSubheader from '../../DashboardSubheader';
import { StatusInfoType } from '../../../../types/reviewStatus';
import {
  getDocReviewStatusIcon,
  docReviewStatusStyle,
} from '../ui/reviewStyle';
import { IonIcon } from '@ionic/react';
import { IonicButton } from 'ionic-ui';

type Props = StatusInfoType;

export default function VerificationStatus({
  status,
  nextReview,
  reviewedAt,
}: Props) {
  const statusPack = useMemo(() => {
    const statusPack = {
      icon: getDocReviewStatusIcon(status),
      header: 'rejected',
      subheader:
        'Your business is not approved to sell pharmaceutical products on Swift Medix.',
    };
    if (status === 'rejected') return statusPack;
    if (status === 'approved')
      return {
        ...statusPack,
        header: 'fully verified',
        subheader:
          'Your business is verified and approved to sell pharmaceutical products on Swift Medix.',
      };
    if (status === 'pending')
      return {
        ...statusPack,
        header: 'under Review',
      };
    return statusPack;
  }, [status]);

  const statusStyle = docReviewStatusStyle(status);
  return (
    <div className="space-y-2">
      <DashboardSubheader>Verification Status</DashboardSubheader>
      <div
        className={`rounded-2xl text-center medium-emphasis-text flex flex-col items-center justify-center ${statusStyle} p-6 gap-4 block`}
      >
        {/* ICON */}
        <div
          className={`rounded-full w-8 h-8 box-content p-2 ${statusStyle} bg-white/15`}
        >
          <IonIcon icon={statusPack.icon} className="size-8" />
        </div>
        <h6 className="capitalize text-customs-dark-blue font-semibold">
          {statusPack.header}
        </h6>
        <p>{statusPack.subheader}</p>

        {reviewedAt && (
          <p>
            <span className="mr-1 text-customs-dark-blue font-medium">
              {status === 'approved' ? 'Approved on:' : 'Reviewed on'}
            </span>
            <span>{reviewedAt}</span>
          </p>
        )}

        {nextReview && (
          <p>
            <span className="mr-1 text-customs-dark-blue font-medium">
              Next review:
            </span>
            <span>{nextReview}</span>
          </p>
        )}

        {status === 'approved' && (
          <IonicButton variant="outline">Download Certificate</IonicButton>
        )}
      </div>
    </div>
  );
}
